/**
 * Event class
 *
 * @author Reinier Feijen
 */
export default class Event {
    constructor(type, data) {
        this.type = type;
        this.data = data;
        this.target = null;
        this.cancelled = false;
    };

    stopImmediatePropagation() {
        this.cancelled = true;
    };
}

//Some often used event types:
Event.PROGRESS = "PROGRESS";
Event.CLOSE = "CLOSE";
Event.COMPLETE = "COMPLETE";
Event.CANCEL = "CANCEL";
Event.CHANGE = "CHANGE";
Event.SELECT = "SELECT";
Event.DESELECT = "DESELECT";
Event.START = "START";
Event.BACK = "BACK";
Event.INTRO_COMPLETE = "INTRO_COMPLETE";
Event.OUTRO_COMPLETE = "OUTRO_COMPLETE";
Event.HELP = "HELP";